export enum EExerciseSpecifications {
    RPE_EASY = 'rpe_easy',
    RPE_MEDIUM = 'rpe_medium',
    RPE_HARD = 'rpe_hard',
    TRACKERS_CHECK = 'trackers_check',
    TIMER = 'timer',
    CUES = 'cues',
    MISSABLE = 'missable',
    SUMMARY = 'summary',
    GENERIC_TRANSITION = 'generic_transition',
    INDIVIDUAL = 'individual',
    ACTIVITY = 'activity',
    LAST_MAN_STANDING = 'last_man_standing',
    TEAM_VERSUS = 'team_versus',
    REPS = 'reps',
    FOCUS_GROUND = 'focus_ground',
    RIGHT_LEFT_DATA = 'right_left_data',
    TIMED = 'timed',
    CALORIES = 'calories',
    COUNTABLE = 'countable',
    ROUND = 'round',
    TRASH_TALK = 'trash_talk',
    RACE = 'race',
    SMASH = 'smash',
    POWER = 'power',
    INTENSITY = 'intensity',
    SPEED = 'speed',
    PAIR_DISPLAY = 'pair_display',
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/config/EExerciseSpecifications.ts